import { Link } from 'react-router-dom';

export default function SafetySection() {
  return (
    <section id="safety" className="py-16 md:py-24 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          <div className="flex-1 order-2 lg:order-1">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20conceptual%20still%20life%20of%20a%20transparent%20glass%20shield%20hovering%20protectively%20over%20a%20small%20collection%20of%20shopping%20items%20including%20a%20folded%20garment%20and%20a%20product%20tag%20on%20a%20soft%20cream%20surface%20warm%20golden%20hour%20backlighting%20creating%20a%20gentle%20glow%20around%20the%20shield%20trust%20and%20protection%20theme%20editorial%20product%20photography%20with%20warm%20amber%20and%20cream%20tones&width=800&height=600&seq=safety-v2-section&orientation=landscape"
                alt="Safe shopping with AllChinaBuy Spreadsheet"
                title="AllChinaBuy Spreadsheet safety guide"
                className="w-full h-auto object-cover"
              />
              <div className="absolute top-4 left-4">
                <span className="inline-block px-3 py-1 bg-background-50/90 text-foreground-900 text-xs font-medium rounded-full">
                  Safety First
                </span>
              </div>
            </div>
          </div>

          <div className="flex-1 order-1 lg:order-2">
            <span className="inline-block px-4 py-1.5 rounded-full border border-secondary-300/60 bg-secondary-100/50 text-secondary-900 text-xs font-medium mb-5">
              Shopping Safety
            </span>
            <h2 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-950 mb-5 leading-tight">
              How to Buy Safely with the<br />AllChinaBuy Spreadsheet
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              Safe shopping starts with trusted information. Our <strong>AllChinaBuy Spreadsheet</strong> guides help you verify sellers, review QC images, compare products, understand shipping methods, and reduce purchasing risks. Every seller in the spreadsheet goes through a verification process before being listed.
            </p>

            <div className="flex flex-col gap-4 mb-7">
              {[
                'Verify seller reputation and history',
                'Review QC photos before shipping',
                'Compare products across multiple sellers',
                'Understand shipping methods and timelines',
                'Use payment protection for every order',
              ].map((item, idx) => (
                <div key={idx} className="flex items-start gap-3">
                  <span className="w-5 h-5 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mt-0.5 flex-shrink-0">
                    <i className="ri-check-line text-xs"></i>
                  </span>
                  <span className="text-sm text-foreground-700">{item}</span>
                </div>
              ))}
            </div>

            <Link
              to="/allchinabuy-spreadsheet-guide"
              className="inline-flex items-center gap-2 px-6 py-3 bg-secondary-500 text-background-50 dark:text-foreground-950 font-medium rounded-full hover:bg-secondary-600 transition-colors whitespace-nowrap cursor-pointer text-sm"
            >
              Read Safety Guide
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-xs"></i>
              </span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}